import { DrawerFilterType } from '../../../models';

export const phasesFilters = [
  {
    label: 'Start Date',
    name: 'startDate',
    type: DrawerFilterType.DATE,
    value: undefined,
  },
  {
    label: 'End Date',
    name: 'endDate',
    type: DrawerFilterType.DATE,
    value: undefined,
  },
];
